import UserInfoRow from './UserInfoRow';
import TippingTipsDetails from './TippingTipsDetails';
import TippingTipsControls from './TippingTipsControls';
// import BetDetailsView from './BetDetails';
import GameInfoView from './GameInfo';
import WidgetLadder from './WidgetLadder';
// import TipRowView from './TipRow';

export { GameInfoView };
export { WidgetLadder };
// export { BetDetailsView };
// export { TipRowView };
export { UserInfoRow };
export { TippingTipsDetails };
export { TippingTipsControls };

export default {
	UserInfoRow,
	TippingTipsDetails,
	TippingTipsControls,
	// BetDetailsView,
	GameInfoView,
	WidgetLadder,
	// TipRowView
}